import { forwardRef } from 'react';

import Box from '@mui/material/Box';

import { RouterLink } from 'src/routes/components';

import logoFull from 'src/assets/images/logo-full.png';
import logoSingle from 'src/assets/images/logo-single.png'

import { useAuthContext } from 'src/auth/hooks';

import { logoClasses } from './classes';

// ----------------------------------------------------------------------

export const Logo = forwardRef(
  (
    { width, href = '/', height, isSingle = true, disableLink = false, className, isShowLogo = true, logoUrl = null, full = false, sx, ...other },
    ref
  ) => {

    const { user } = useAuthContext();

    const logo = user?.CompanyLogoPath || full ? logoFull : logoSingle

    return (
      <Box
        ref={ref}
        component={RouterLink}
        href={user ? '#' : href}
        className={logoClasses.root.concat(className ? ` ${className}` : '')}
        aria-label="Logo"
        sx={{
          width: width ?? full ? 160 : 40,
          flexShrink: 0,
          display: 'inline-flex',
          alignItems: 'center',
          gap: 1,
          textDecoration: 'none',
          color: 'primary.main',
          ...(disableLink && { pointerEvents: 'none' }),
          ...sx,
        }}
        {...other}
      >
        <Box
          component="img"
          src={logo}
          alt="Logo"
          sx={{
            width: '100%',
            height: 'auto',
            aspectRatio: full ? undefined : 1,
          }}
        />
      </Box>
    );
  }
);
